import axios from 'axios';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { BASE_PATH } = publicRuntimeConfig;

export const bff = axios.create({
  baseURL: `${BASE_PATH}/api`,
});
